import { ChatMessage, GuidedAction } from "../lib/types";
import { ChatMessage as ChatMessageItem } from "./ChatMessage";
import type { Product } from '../lib/mockData';

interface ChatListProps {
  messages: ChatMessage[];
  onProductSelect?: (product: Product) => void;
  onOptionSelect?: (options: Array<{ index: number; label: string }>) => void;
  onActionSelect?: (action: GuidedAction) => void;
  // Anchoring
  lastUserMessageId?: string | null;
  setUserAnchor?: (el: HTMLElement | null) => void;
  onUserAction?: () => void;
}

export function ChatList({ messages, onProductSelect, onOptionSelect, onActionSelect, lastUserMessageId, setUserAnchor, onUserAction }: ChatListProps) {
  return (
    <div className="flex flex-col space-y-4 px-8 pt-8 pb-2">
      {messages.map((message, idx) => {
        return (
          <ChatMessageItem 
            key={message.id} 
            message={message} 
            onProductSelect={onProductSelect}
            onOptionSelect={onOptionSelect}
            onActionSelect={onActionSelect}
            userAnchorRef={(message.isUser && message.id === lastUserMessageId) ? (setUserAnchor as any) : undefined}
            onUserAction={onUserAction}
          />
        );
      })}
    </div>
  );
} 